__turbopack_context__.v({
  "dialogContainer": "TaxReturnDeliveryDialog-module__aCLZeG__dialogContainer",
  "iframe": "TaxReturnDeliveryDialog-module__aCLZeG__iframe",
});
